import { useCallback, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { useRetryableQuery } from './useRetryableQuery';

export const useSuperAdmin = () => {
  const { user, loading: authLoading } = useAuth();

  const queryFn = useCallback(async () => {
    if (!user) return false;
    
    const { data, error } = await supabase.rpc('is_super_admin', {
      _user_id: user.id
    });

    if (error) throw error;
    return data === true;
  }, [user]);

  const { data, loading, error, retry } = useRetryableQuery({
    queryFn,
    enabled: !authLoading && !!user,
    maxRetries: 2,
    showToastOnError: false,
    errorMessage: 'Erreur lors de la vérification des droits admin',
  });

  // Memoize the result
  const isSuperAdmin = useMemo(() => data ?? false, [data]);

  return { 
    isSuperAdmin, 
    loading: authLoading || loading,
    error,
    retry,
  };
};
